export class RegisterUserFakeDb {
  public static users = [
    {
      name: "Robert Leidl",
      email: "robert@gmail.com",
      password: "robertrobert",
    },
  ];
}
